import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=a5df207e&scoped=true"
import script from "./AccountSettings.vue?vue&type=script&lang=js"
export * from "./AccountSettings.vue?vue&type=script&lang=js"
import style0 from "./AccountSettings.vue?vue&type=style&index=0&id=a5df207e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5df207e",
  null
  
)

export default component.exports